import { render, staticRenderFns } from "./GroupPreview.vue?vue&type=template&id=77d8c8ea&"
import script from "./GroupPreview.vue?vue&type=script&lang=ts&"
export * from "./GroupPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports